var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9383",
    "data-name": "Group 9383",
    transform: "translate(-0.033 0.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9378",
    "data-name": "Group 9378",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0.033 -0.142)",
    fill: "#151d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL0_wght400_GRAD0_opsz24",
    d: "M8.349,20.874h4.175v-8.35h8.349V8.349H12.524V0H8.349V8.349H0v4.175H8.349ZM10.437,10.436Z",
    transform: "translate(16.046 0.892) rotate(45)",
    fill: "#fff",
    stroke: "#151d2b",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.9d85185cd5ba23784629cbb2341a18ed.svg";
export { ForwardRef as ReactComponent };